<section class="max-w-lg mx-auto bg-white shadow-xl rounded-xl overflow-hidden border border-gray-300">

	<!-- Header with Background and Gradient -->
	<header class="bg-gradient-to-r from-gray-900 to-gray-800 text-gray-100 text-center py-8 px-6">
		<h1 class="text-4xl font-bold leading-tight drop-shadow-md">
      &#161;Bienvenido a <span class="text-blue-400">{{ companyName }}</span>!
    </h1>
		<p class="text-gray-300 text-lg mt-2 font-light">{{ tagline }}</p>
	</header>

	<!-- Image -->
	<div class="text-center bg-gray-100 p-6">
		<img src="assets/img/emailpicture.png" alt="Bienvenido a {{ companyName }}" class="mx-auto rounded-lg shadow-lg w-full max-w-md">
	</div>

	<!-- Main Content -->
	<main class="p-6 text-gray-700">
		<p class="text-lg leading-relaxed text-gray-800">
			Gracias por unirte a nuestra comunidad. En <strong>{{ companyName }}</strong>, nos especializamos en ofrecer soluciones tecnol&#243;gicas innovadoras adaptadas a tus necesidades.
		</p>

		<p class="mt-4 text-gray-600">
			Nuestro compromiso es proporcionar <strong>excelencia</strong> en productos y un servicio cercano que genere conexiones duraderas.
		</p>

		<section class="mt-6">
			<h2 class="text-xl font-semibold text-gray-900 border-l-4 border-blue-500 pl-3">&#191;Qu&#233; obtendr&#225;s con nosotros?</h2>
			<ul class="mt-4 space-y-3 list-none pl-0">
				<li class="flex items-center space-x-2">
					<span class="text-blue-500 text-xl">&#10004;</span>
					<span class="text-gray-700">Contenido exclusivo sobre tecnolog&#237;a</span>
				</li>
				<li class="flex items-center space-x-2">
					<span class="text-blue-500 text-xl">&#10004;</span>
					<span class="text-gray-700">Soluciones estrat&#233;gicas para tu empresa</span>
				</li>
				<li class="flex items-center space-x-2">
					<span class="text-blue-500 text-xl">&#10004;</span>
					<span class="text-gray-700">Un equipo comprometido con la innovaci&#243;n</span>
				</li>
			</ul>
		</section>

		<p class="mt-6 text-gray-600">
			Estamos aqu&#237; para ayudarte. Si tienes preguntas, cont&#225;ctanos.
		</p>

	</main>

	<!-- Action Button -->
	<section class="text-center py-6">
		<a href="https://www.dev.arq-it.cl" class="inline-block px-6 py-2 border border-blue-600 text-blue-600 rounded-lg text-lg font-semibold transition-all duration-300 hover:bg-blue-600 hover:text-white">
        Vis&#237;tanos
    </a>
	</section>

	<!-- Footer -->
	<footer class="bg-gray-900 text-gray-400 text-center py-5 text-sm">
		<p>&copy; 2024 <strong class="text-gray-200">{{ companyName }}</strong>. Todos los derechos reservados.</p>
		<div class="mt-2">
			<a href="/unsubscribe" class="text-blue-400 hover:text-blue-300 transition-all">Cancelar suscripci&#243;n</a>
		</div>
	</footer>

</section>